/**
 * brandConfig.js — Sports.TV backend identity defaults (non-secret).
 *
 * Single source of truth for the hardcoded fallbacks used when the matching
 * REACT_APP_* / window.* runtime values are absent. The DSP API key is NOT here
 * — it is injected at runtime (see runtimePublicEnv.js) and never committed.
 *
 * Keep this dependency-free: it is imported by src/index.js before the app boots.
 */
export const SPORTSTV_COMPANY_ID = '609965714da94049f75b7ec2';
export const SPORTSTV_API_BASE = 'https://sportstv.api.myspotlight.tv';
// Sports.TV media/VOD CDN (verified: serves the HLS manifests). Follows the
// per-brand cachefly pattern (chillfree -> chillfreedspmedia, sportstv -> sportstvdspmedia).
export const SPORTSTV_MEDIA_CDN = 'https://sportstvdspmedia.cachefly.net';
